import styled, {css} from 'styled-components';
import SimpleButton from '../../../Buttons/SimpleButton';
import FieldSet from '../../../Forms/Inputs/FieldSet';
import TextInput from '../../../Forms/Inputs/TextInput';
import Icon from '../../../Icon/Icon';
import {
  bordersColor,
  darkGrayColor,
  primaryColor,
} from '../../../constants/colors';
import {mediaMaxTablet, mediaMinTablet} from '../../../constants/customMedia';
import {fsM, fsXXS, fwMediumBold} from '../../../constants/typography';

export const StyledTextInput = styled(TextInput)`
  margin-bottom: 16px;
`;

export const UserDetailsFieldSet = styled(FieldSet)<{hidden?: boolean}>`
  margin-bottom: 30px;
  flex-direction: column;
  ${props =>
    props.hidden &&
    css`
      display: none;
    `}
`;

export const FormRow = styled.div`
  display: flex;
  margin-bottom: 16px;
`;

export const FormRowTwoEqualItems = styled(FormRow)`
  display: flex;
  margin-bottom: 0px;
  gap: 1rem;
  > section {
    flex: 1;
  }
  @media ${mediaMaxTablet} {
    display: block;
  }
`;

export const GrowingTextInput = styled(TextInput)`
  flex-grow: 1;
`;
export const AddressHouseNumberInput = styled(TextInput)`
  width: 111px;
  flex-grow: 0;
  flex-shrink: 0;
  margin-left: 16px;
`;
export const ZipCodeInput = styled(AddressHouseNumberInput)`
  margin-left: 0;
  margin-right: 16px;
`;

export const SubmitButton = styled(SimpleButton)<{$addMarginTop?: boolean}>`
  ${({disabled}) =>
    disabled &&
    css`
      pointer-events: none;
    `}

  ${({$addMarginTop}) =>
    $addMarginTop &&
    css`
      margin-top: 24px;
    `}

  @media ${mediaMinTablet} {
    max-width: 320px;
  }
`;

export const DropDownSubline = styled.div`
  font-size: ${fsXXS}px;
  ${fwMediumBold};
  line-height: 1.33;
  letter-spacing: normal;
  color: ${darkGrayColor};
  margin-top: 8px;
  margin-bottom: 8px;
  margin-left: 16px;
`;

export const DropDownCountryTitle = styled.h1`
  font-size: ${fsM}px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.3;
  letter-spacing: normal;
  text-align: center;
  color: ${primaryColor};
`;

export const NestedSearchBarInput = styled(TextInput)<{isMobile: boolean}>`
  height: 44px;
  margin: 16px;
  margin-bottom: 20px;
  & > button {
    /* 
  Hack to move the adornment icon to the rigth
  Because it is in web-core, and likely won't be reused anywhere else in such a manner
  */
    left: auto;
    right: 6px;
  }
`;

export const StyledForm = styled.form`
  margin-bottom: 60px;
  @media ${mediaMinTablet} {
    margin-bottom: 120px;
  }
`;

export const AddOrderNumberButton = styled.button`
  font-size: ${fsXXS}px;
  ${fwMediumBold};
  line-height: 1.33;
  color: ${darkGrayColor};
  border: none;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const AddButtonIcon = styled(Icon)`
  border-radius: 3px;
  border: solid 1px ${bordersColor};
  margin-right: 6px;
  fill: ${darkGrayColor};
`;

export const FormSection = styled.section<{
  hidden?: boolean;
  short?: boolean;
}>`
  margin-bottom: ${({short}) => (short ? '16px' : '30px')};

  ${props =>
    props.hidden &&
    css`
      display: none;
    `}
`;
